import React, { useRef } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';

import { Text, Wrapper } from 'widget/components';
import { useChatBodyContext } from '../chat-body-context';

// import {getValidAttachs} from './actions';
import { useGetIsFormDisabled } from './hooks';
import { Values } from './composer-env';
// import Attachs from './attachs/attachs';
import AttachsPreview from './attachs-preview/attachs-preview';
import Content from './content/content';
import EmojiPicker from './emoji-picker/emoji-picker';
import QuotedMsg from './quoted-msg/quoted-msg';
import Submit from './submit/submit';

const initialValues: Values = { attachs: [], content: '' };

const Composer = () => {
  const { accessToken, quotedMessage, sendMsg, setQuotedMessage } =
    useChatBodyContext();

  const { t } = useTranslation();
  const getIsFormDisabled = useGetIsFormDisabled();
  const messageInputRef = useRef<HTMLTextAreaElement>(null);

  // const sendAttachs = async (values: Values) => {
  //   const validAttachs = getValidAttachs(values.attachs);
  // };

  const sendContent = (values: Values) =>
    sendMsg({
      content: values.content,
      file_url: '',
      quotedMsgId: quotedMessage?.id ?? '',
      type: 'message',
    });

  const handleSubmit = async (
    values: Values,
    helpers: FormikHelpers<Values>,
  ) => {
    const isDisabled = getIsFormDisabled(values);
    if (isDisabled) return true;

    // const validAttachs = getValidAttachs(values.attachs);
    // if (validAttachs.length > 0) await sendAttachs(values);

    if (values.content) sendContent(values);

    helpers.resetForm();
    setQuotedMessage(undefined);

    return true;
  };

  return (
    <div className="whatcrm-widget-chat__composer">
      <div className="whatcrm-widget-chat__wrapper">
        {accessToken !== null ? (
          <>
            {quotedMessage && <QuotedMsg />}

            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ values }) => (
                <Form>
                  {values.attachs.length > 0 && <AttachsPreview />}

                  <Wrapper>
                    <Content ref={messageInputRef} />
                    <EmojiPicker messageInputRef={messageInputRef} />
                    {/* <Attachs /> */}

                    <Submit />
                  </Wrapper>
                </Form>
              )}
            </Formik>
          </>
        ) : (
          <Text color="navy">{t`Sorry, chat is temporarily unavailable.`}</Text>
        )}
      </div>
    </div>
  );
};

export default Composer;
